import Alpine from "alpinejs";
import Typed from "typed.js";

// --- Worm canvas animation ---
// Анимированный «червь» на canvas в фоне джумботрона.
// Голова плавно следует за курсором, а когда мышь неактивна —
// автоматически летит по траектории Лиссажу.
(function () {
  const canvas = document.getElementById("jumbotron-worm");
  if (!canvas) return;
  const ctx = canvas.getContext("2d");

  // Радиус каждого «сегмента» тела
  const RADIUS = 64;
  // Цвет фона [R, G, B]
  const BG = [77, 105, 255];
  // Цвет головы червя [R, G, B]
  const WORM = [255, 200, 61];

  // Параметры скорости и длины хвоста зависят от ориентации.
  // При замедлении голова за кадр проходит меньше пикселей — точки тела
  // «слипаются», хвост визуально укорачивается. Компенсируем увеличением
  // MAX_POINTS пропорционально коэффициенту замедления (0.03 / 0.018 ≈ 1.67).
  // LERP — плавность следования головы (чем меньше — тем ленивее).
  // AUTO_SPEED — шаг угла автопилота за кадр.
  // Все три значения выставляются в resize() при каждом изменении размера.
  let MAX_POINTS, LERP, AUTO_SPEED;

  // Синхронизируем внутреннее разрешение canvas с его CSS-размером,
  // чтобы не было размытия при отрисовке.
  // При альбомной ориентации (W > H) скорости снижаются — экран шире,
  // движение на нём выглядит быстрее, поэтому замедляем.
  let W, H;
  function resize() {
    W = canvas.width = canvas.offsetWidth;
    H = canvas.height = canvas.offsetHeight;
    const landscape = W > H;
    MAX_POINTS = landscape ? 210 : 127;
    LERP = landscape ? 0.018 : 0.03;
    AUTO_SPEED = landscape ? 0.008 : 0.015;
  }
  resize();
  // Следим за изменением размера контейнера (ресайз окна, изменение лейаута)
  const ro = new ResizeObserver(resize);
  ro.observe(canvas);

  // История позиций тела: points[0] — голова, points[n] — кончик хвоста
  const points = [];

  // Текущая позиция курсора в координатах canvas
  let mouseX = W / 2,
    mouseY = H / 2;
  // true, пока мышь двигалась последние 3 секунды
  let mouseActive = false;
  let mouseTimer = null;

  // Сглаженная позиция головы (интерполируется к цели каждый кадр)
  // Начинается за пределами экрана, чтобы червь «въехал» при старте
  let headX = -200,
    headY = H / 2;

  // Угол для автопилота (Лиссажу)
  let angle = Math.PI;

  // Переводит координаты события (viewport) в координаты canvas
  function toCanvas(clientX, clientY) {
    const rect = canvas.getBoundingClientRect();
    return { x: clientX - rect.left, y: clientY - rect.top };
  }

  // Слушаем события на родительском контейнере, а не на canvas:
  // поверх canvas лежит абсолютный div с заголовком и typed-текстом,
  // он перехватывает события мыши раньше canvas.
  const container = canvas.parentElement;

  // Включаем режим следования за мышью; через 3 сек без движения — возврат на автопилот
  container.addEventListener("mousemove", (e) => {
    const p = toCanvas(e.clientX, e.clientY);
    mouseX = p.x;
    mouseY = p.y;
    mouseActive = true;
    clearTimeout(mouseTimer);
    mouseTimer = setTimeout(() => {
      mouseActive = false;
    }, 3000);
  });

  // Touch tracking disabled — blocks page scroll on mobile

  function animate() {
    // Определяем целевую точку для головы
    let targetX, targetY;
    if (mouseActive) {
      // Следуем за курсором
      targetX = mouseX;
      targetY = mouseY;
    } else {
      // Автопилот: фигура Лиссажу, занимает 70% ширины и 50% высоты canvas
      targetX = W / 2 + Math.cos(angle) * (W * 0.35);
      targetY = H / 2 + Math.sin(angle * 1.3) * (H * 0.25);
      angle += AUTO_SPEED;
    }

    // Плавно двигаем голову к цели (линейная интерполяция)
    headX += (targetX - headX) * LERP;
    headY += (targetY - headY) * LERP;

    // Добавляем новую позицию головы в начало массива, убираем лишние с хвоста
    points.unshift({ x: headX, y: headY });
    if (points.length > MAX_POINTS) points.pop();

    // Заливаем фон
    ctx.fillStyle = "rgb(" + BG[0] + "," + BG[1] + "," + BG[2] + ")";
    ctx.fillRect(0, 0, W, H);

    // Рисуем хвост от кончика к голове: каждый сегмент интерполирует цвет
    // от фонового (кончик хвоста) до цвета червя (у головы) по квадратичной кривой
    for (let i = points.length - 1; i >= 1; i--) {
      const p = points[i];
      const ratio = 1 - i / points.length; // 0 у хвоста, ~1 у головы
      const t = Math.pow(ratio, 2); // квадратичное ускорение перехода
      const r = Math.round(BG[0] + (WORM[0] - BG[0]) * t);
      const g = Math.round(BG[1] + (WORM[1] - BG[1]) * t);
      const b = Math.round(BG[2] + (WORM[2] - BG[2]) * t);
      ctx.beginPath();
      ctx.arc(p.x, p.y, RADIUS, 0, Math.PI * 2);
      ctx.fillStyle = "rgb(" + r + "," + g + "," + b + ")";
      ctx.fill();
    }

    // Рисуем голову поверх хвоста полным цветом червя
    if (points.length > 0) {
      ctx.beginPath();
      ctx.arc(points[0].x, points[0].y, RADIUS, 0, Math.PI * 2);
      ctx.fillStyle = "rgb(" + WORM[0] + "," + WORM[1] + "," + WORM[2] + ")";
      ctx.fill();
    }

    requestAnimationFrame(animate);
  }

  animate();
})();

// --- Typed.js: анимация печатающегося текста в джумботроне ---
document.addEventListener("alpine:init", () => {
  Alpine.data("typedText", () => ({
    init() {
      new Typed(this.$refs.typedJs, {
        stringsElement: this.$refs.items,
        typeSpeed: 50,
        backSpeed: 50,
        backDelay: 5000,
        loop: true,
        cursorChar: "_",
      });
    },
  }));
});
